import React from 'react'
import { Switch, Route, Redirect, useHistory } from 'react-router-dom'
import './dashboard.css'
import Sidebar from './Sidebar'
import DashboardHome from './DashboardHome'
import CompaniesPage from './CompaniesPage'
import CompanyDetail from './CompanyDetail'
import UsersList from './UsersList'
import UserDetail from './UserDetail'
import ReconciliationProgress from './ReconciliationProgress'
import BulkPermissions from './BulkPermissions'
import BannersList from './BannersList'
import SigninThemesList from './SigninThemesList'
import RoleIpWhitelistList from './RoleIpWhitelistList'
import CompanyGroupDetail from './CompanyGroupDetail'
import PrivacyList from './PrivacyList'
import PrivacySubjectSearchPage from './PrivacySubjectSearchPage'
import PortalHealth from './PortalHealth'
import { canAccessPrivacyModule } from '../../utils/privacyAccess'
import { canAccessPortalHealth } from '../../utils/portalHealthAccess'

export function Dashboard({ userEmail }) {
  const history = useHistory()
  const sessionEmail = userEmail || localStorage.getItem('userEmail')

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('userEmail')
    window.location.href = '/login'
  }

  const handleNavigate = (view) => {
    switch (view) {
      case 'dashboard':
        history.push('/dashboard')
        break
      case 'companies':
        history.push('/empresas')
        break
      case 'users':
        history.push('/usuarios')
        break
      case 'reconciliation-progress':
        history.push('/avance-conciliacion')
        break
      case 'bulk-permissions':
        history.push('/permisos-masivos')
        break
      case 'communications':
        history.push('/comunicaciones')
        break
      case 'signin-themes':
        history.push('/apariencia-login')
        break
      case 'role-ip-whitelist':
        history.push('/whitelist-ip')
        break
      case 'privacy':
        history.push('/privacidad')
        break
      case 'privacy-subject-search':
        history.push('/privacidad/localizar')
        break
      case 'portal-health':
        history.push('/salud')
        break
      default:
        history.push('/dashboard')
    }
  }

  const handleSelectCompany = (companyId) => {
    history.push(`/empresas/${companyId}`)
  }

  const handleSelectUser = (userId) => {
    history.push(`/usuarios/${userId}`)
  }

  const handleBackToCompanies = () => {
    history.push('/empresas')
  }

  const handleBackToUsers = () => {
    history.push('/usuarios')
  }

  const handleBackToCompanyGroups = () => {
    history.push('/empresas/grupos')
  }

  return (
    <div className="dashboard-layout">
      <Sidebar
        userEmail={sessionEmail}
        onLogout={handleLogout}
      />
      <main className="main-content">
        <Switch>
          <Route exact path="/dashboard">
            <DashboardHome onNavigate={handleNavigate} />
          </Route>
          <Route exact path="/empresas">
            <CompaniesPage
              onSelectCompany={handleSelectCompany}
              activeTab="empresas"
            />
          </Route>
          <Route exact path="/empresas/grupos">
            <CompaniesPage
              onSelectCompany={handleSelectCompany}
              activeTab="grupos"
            />
          </Route>
          <Route path="/empresas/grupos/:id">
            {({ match }) => (
              <CompanyGroupDetail
                groupId={match.params.id}
                onBack={handleBackToCompanyGroups}
                key={match.params.id}
              />
            )}
          </Route>
          <Route path="/empresas/:id">
            {({ match }) => (
              <CompanyDetail
                companyId={match.params.id}
                onBack={handleBackToCompanies}
                onSelectUser={handleSelectUser}
                key={match.params.id}
                currentUserEmail={sessionEmail}
              />
            )}
          </Route>
          <Route exact path="/usuarios">
            <UsersList onSelectUser={handleSelectUser} />
          </Route>
          <Route exact path="/avance-conciliacion">
            <ReconciliationProgress />
          </Route>
          <Route exact path="/permisos-masivos">
            <BulkPermissions />
          </Route>
          <Route exact path="/comunicaciones">
            <BannersList />
          </Route>
          <Route exact path="/apariencia-login">
            <SigninThemesList />
          </Route>
          <Route exact path="/whitelist-ip">
            <RoleIpWhitelistList />
          </Route>
          <Route exact path="/grupos-empresariales">
            <Redirect to="/empresas/grupos" />
          </Route>
          <Route path="/grupos-empresariales/:id">
            {({ match }) => (
              <Redirect to={`/empresas/grupos/${match.params.id}`} />
            )}
          </Route>
          <Route exact path="/privacidad/localizar">
            {canAccessPrivacyModule() ? (
              <PrivacySubjectSearchPage />
            ) : (
              <Redirect to="/dashboard" />
            )}
          </Route>
          <Route exact path="/privacidad">
            {canAccessPrivacyModule() ? <PrivacyList /> : <Redirect to="/dashboard" />}
          </Route>
          <Route exact path="/salud">
            {canAccessPortalHealth(sessionEmail) ? (
              <PortalHealth />
            ) : (
              <Redirect to="/dashboard" />
            )}
          </Route>
          <Route path="/usuarios/:id">
            {({ match }) => (
              <UserDetail
                userId={match.params.id}
                onBack={handleBackToUsers}
                key={match.params.id}
                currentUserEmail={sessionEmail}
              />
            )}
          </Route>
          <Route exact path="/">
            <Redirect to="/dashboard" />
          </Route>
          <Redirect to="/dashboard" />
        </Switch>
      </main>
    </div>
  )
}

export default Dashboard
